<template>
  <div>
    <PasswordProtection v-if="shopObj && shopObj.password_enabled" />
    <DisabledAlert name="AMP" to="amp_settings" v-if="db.status && !db.status.amp && showHere" />
    <p class="section-title" v-if="shopObj">AMP</p>
    <router-view v-if="routeReady"></router-view>
    <Loading v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PasswordProtection from '@/components/PasswordProtection'
import DisabledAlert from '@/components/DisabledAlert'
import routeReady from '@/mixins/routeReady'

export default {
  mixins: [ routeReady ],
  components: {
    PasswordProtection,
    DisabledAlert
  },
  computed: {
    ...mapState([ 'shopObj', 'db' ]),
    showHere: function () {
      return !this.$route.path.endsWith('/settings')
    }
  }
}
</script>
